import * as styles from "./TimePickerValue.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useTimePickerContext } from "./TimePicker.context";
import type { TimePickerValueProps } from "./TimePicker.types";
import { formatTime, formatTypedTime } from "./timeMath";

const EMPTY = "--:--";

export function TimePickerValue({
  placeholder = EMPTY,
  className,
}: TimePickerValueProps): JSX.Element {
  const { selected, range, selectedRange, typing } = useTimePickerContext();

  const [start, end] = selectedRange;

  const shown = (endpoint: "start" | "end", time: typeof start) =>
    typing?.endpoint === endpoint
      ? formatTypedTime(typing.digits)
      : time
        ? formatTime(time)
        : EMPTY;

  const formatted = range
    ? null === start && null === end && !typing
      ? null
      : `${shown("start", start)} – ${shown("end", end)}`
    : typing
      ? formatTypedTime(typing.digits)
      : selected && formatTime(selected);

  return (
    <span
      data-slot="time-picker-value"
      className={clsx(
        styles.value,
        !formatted && styles.placeholder,
        className,
      )}
    >
      {formatted || placeholder}
    </span>
  );
}
